export function useTaxConversion() {
    return {
        convert: (value?: number): string | undefined => value?.toLocaleString('fi-FI'),
    };
}
